import { useSelector } from "react-redux";
import { AppStore } from "../store";
import { FinancialMoodState } from "../types/financial-mood";

export const useGetFinancialMood = () => {
  return useSelector<AppStore, FinancialMoodState>(
    (store) => store.financialMoodState
  );
};
